import { AppService } from '../main/app.service';
import { BaseService } from '../base/base.service';

export class TwinfieldService extends BaseService<any> {

    /** Constructor */

    constructor(
        protected Restangular: Restangular.IService,
        protected AppService: AppService,
        private localStorageService: ng.local.storage.ILocalStorageService
    ){
        "ngInject";
        super(Restangular, AppService, 'twinfield');
    }

    /**
     * Check if Twinfield API token in APIis still valid.
     *
     * @return  {void}
     */

    public verifyToken = () => {

        return this.Restangular.one( 'twinfield' ).withHttpConfig({cache: false}).customGET( '' ); }

    /**
     * Set Twinfield API token with oAuth2 code
     *
     * @return  {void}
     */

    public setToken = (code) => {

        return this.Restangular.one( 'twinfield' ).withHttpConfig({cache: false}).customGET( code, {
            
            redirectUrl: window.location.protocol + '//' + window.location.host + '/app/twinfield' }); }

    /**
     * Set redirect URL for
     *
     * @return  {void}
     */
    
    public setTwinfieldRedirectUri = () => {

        /** Log */

        console.log( 'twinfieldRedirect: ' + window.location.pathname + window.location.search );

        /** Set URI */

        this.localStorageService.set( 'twinfieldRedirect', window.location.pathname + window.location.search ); }

}


// WEBPACK FOOTER //
// ./src/app/services/twinfield.service.ts